import { dmnAjaxCall } from "./helpers";
const articleContent = document.querySelector(".article-content");

if (articleContent) {
  const imageCarouselSections = articleContent.getElementsByClassName(
    "layout--image-carousel"
  );

  function setSectionSize() {
    for (const section of imageCarouselSections) {
      const elementBounding = section.getBoundingClientRect();
      const newWidth =
        elementBounding.width +
        (window.innerWidth - elementBounding.right) +
        "px";
      section.style.width = newWidth;
    }
  }

  window.addEventListener("load", setSectionSize);
  window.addEventListener("resize", setSectionSize);
}

const articleShare = document.querySelector(".article-share");
if (articleShare) {
  const shareToggle = articleShare.querySelector(".article-share-toggle");
  shareToggle.addEventListener("click", function (e) {
    e.preventDefault;
    if (articleShare.classList.contains("active")) {
      articleShare.classList.remove("active");
    } else {
      articleShare.classList.add("active");
    }
  });
}


// Articles Filters

const termsFilters = document.getElementsByClassName('term-filter');
const blogEntriesEl = document.getElementById("blog-entries");
const paginationEl = document.querySelector(".load-more-pagination");

const queryPosts = async (args, resCallback = false) => {

  const { response, error } = await dmnAjaxCall('loadPosts', args);
  if (resCallback) {
    resCallback(response, error);
  } else {
    return { response, error }
  }
}

const getFilters = (loadmore = false) => {

  let selected_terms = [];

  for (const term of termsFilters) {
    if (term.dataset.selected === "1") {
      selected_terms.push(term.dataset.id);
    }
  }

  const args = {
    term_ids: selected_terms,
    page: loadmore == true ? parseInt(paginationEl.dataset.next) : 0
  }
  return args;
}

function termFilterHandler(event) {
  event.preventDefault();

  this.dataset.selected = 0 == parseInt(this.dataset.selected) ? 1 : 0;

  queryPosts(getFilters(), responseFilterHandler);
}

function responseFilterHandler(response, error) {
  blogEntriesEl.innerHTML = response.data.html;

  if (response.data.pagination?.max_num_pages == response.data.pagination?.paged || !response.data.html) {
    paginationEl.style.display = "none";
  } else {
    paginationEl.dataset.next = parseInt(response.data.pagination.paged) + 1;
    paginationEl.dataset.current = parseInt(response.data.pagination.paged);
    paginationEl.dataset.prev = parseInt(response.data.pagination.paged) - 1;
    paginationEl.style.display = "inline-block";
  }
}
if (paginationEl) {
  paginationEl.addEventListener("click", async function (e) {
    e.preventDefault();
    const { response, error } = await queryPosts(getFilters(true));
    blogEntriesEl.innerHTML += response.data.html;
    if (response.data.pagination?.max_num_pages == response.data.pagination?.paged) {
      paginationEl.style.display = "none";
    } else {
      paginationEl.dataset.next = parseInt(response.data.pagination.paged) + 1;
      paginationEl.dataset.current = parseInt(response.data.pagination.paged);
      paginationEl.dataset.prev = parseInt(response.data.pagination.paged) - 1;
    }
  })
}

if (termsFilters.length) {
  for (const term of termsFilters) {
    term.addEventListener('click', termFilterHandler);
  }
}